import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const AuthFooter = () => {
    return (
        <React.Fragment>
            <footer className="bg-light border-top py-3 fixed-bottom">
                <Container className="mx-auto ">
                    <Row className="justify-content-md-center">
                        <Col md="auto">
                         &copy; Grow CashFlow 2023
                        </Col>
                    </Row>
                    
                </Container>
            </footer>
        </React.Fragment>
    );
}

export default AuthFooter;